import React from "react";
import WorldFlag from "react-world-flags";

// UK home nation codes mapped to custom flag image suffixes
// File naming in /public/flags follows: gb-<suffix>.png (e.g. gb-eng.png)
// Map the alpha-2 like codes we receive (EN, SC, WA, NI) to those suffixes
const HOME_NATIONS_MAP = {
  EN: "eng", // England → gb-eng.png
  SC: "sct", // Scotland → gb-sct.png
  WA: "wls", // Wales → gb-wls.png
  NI: "nir"  // Northern Ireland → gb-nir.png
};

export default function Flag({ code, fallback = "", style = {} }) {
  const upperCode = (code || "").toUpperCase();

  // Serve local SVGs for UK home nations
  const localSuffix = HOME_NATIONS_MAP[upperCode];
  if (localSuffix) {
    const src = `/flags/gb-${localSuffix}.png`;
    return <img src={src} alt={fallback || upperCode} style={style} />;
  }

  // Fallback to react-world-flags for all standard ISO 3166-1 alpha-2 codes
  if (code) {
    return <WorldFlag code={code} fallback={fallback} style={style} />;
  }

  // Last resort: show fallback text
  return <span style={style}>{fallback}</span>;
} 